<template>

  <FormulateInput
      v-if="entry.type !== 'editor'"
      :name="entry.name"
      :type="entry.type"
      :label="entry.label"
      :placeholder="entry.placeholder"
      :value="entryValue"
      v-model="valueField"
      :validation="entry.validation"
      :validation-messages="validationMessage"
      :repeatable="entry.repeat"
      :help="entry.help"
      :uploader="entry.uploader"
      :options="entry.options"
      :error-behavior="entry.errorBehavior"
      :disabled="entryDisabled"
      :wrapper-class="wrapperClass"
      :outer-class="outerClass"
      :input-class="inputClass"
      :element-class="elementClass"
  >
    <slot></slot>
  </FormulateInput>
  <div v-else>
    <FormulateInput
        :name="entry.name"
        :type="'hidden'"
        :label="entry.label"
        :placeholder="entry.placeholder"
        :value="entryValue"
        v-model="valueField"
        :validation="entry.validation"
        :validation-messages="validationMessage"
        :repeatable="entry.repeat"
        :add-label="entry.repeatLabel"
        :help="entry.help"
        :uploader="entry.uploader"
        :options="entry.options"
        :error-behavior="entry.errorBehavior"
        :disabled="entryDisabled"
        :wrapper-class="['wrapper-class']"
        :outer-class="entryDouble ? ['outer-class', 'double-time-field-class'] : entryTriple ? ['outer-class', 'triple-field-class'] : entryDoubleFull ? ['outer-class', 'double-full-field-class'] : ['outer-class']"
        :input-class="entryColumn ? ['input-class', 'options-column-class'] : ['input-class']"
        :element-class="entryVertical ? ['element-class', 'vertical-class'] : ['element-class']"
        class="m-0 p-0"
    >
      <slot></slot>
    </FormulateInput>
    <vue-editor
        v-model="valueField"
        class="mb-4"
        :disabled="entryDisabled"
        :editor-toolbar="customToolbar"

    />
  </div>
</template>

<script>
import {VueEditor} from "vue2-editor";

export default {
  name: "customFormulateInput",
  props: {
    entry: {
      type: Object,
      required: true
    },
    entryIndex: {
      type: Number,
      required: true
    },
    entryValue: {
      default: ""
    },
    entryVertical: {
      type: Boolean,
      default: false
    },
    entryDouble: {
      type: Boolean,
      default: false
    },
    entryDoubleFull: {
      type: Boolean,
      default: false
    },
    entryTriple: {
      type: Boolean,
      default: false
    },
    entryColumn: {
      type: Boolean,
      default: false
    },
    entryDisabled: {
      type: Boolean,
      default: false
    }
  },
  components: {VueEditor},
  data() {
    return {
      content: "<h1>Some initial content</h1>",
      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6]
          }
        ],
        [
          "bold",
          "italic",
          "underline",
          "strike"
        ], // toggled buttons
        [
          {
            align: ""
          },
          {
            align: "center"
          },
          {
            align: "right"
          },
          {
            align: "justify"
          }
        ],
        [
          "blockquote",
          "code-block"
        ],
        [
          {
            list: "ordered"
          },
          {
            list: "bullet"
          },
          {
            list: "check"
          }
        ],
        [
          {
            indent: "-1"
          },
          {
            indent: "+1"
          }
        ], // outdent/indent
        [
          {
            color: []
          },
          {
            background: []
          }
        ], // dropdown with defaults from theme
        [
          "link",
          // "image",
          // "video"
        ],
        [
          "clean"
        ] // remove formatting button
      ],
      validationMessage: {
        required: `กรุณากรอก ${this.entry.label ? this.entry.label : this.entry.placeholder}`,
        email: `"${!this.valueField ? '' : this.valueField}" ไม่ใช่รูปแบบของ E-mail ที่ถูกต้อง`,
        min: `${this.entry.label ? this.entry.label : this.entry.placeholder} ต้องมีจำนวนตัวอักษรหรือตัวเลขไม่น้อยกว่า ${6}`,
        max: `${this.entry.label ? this.entry.label : this.entry.placeholder} ต้องมีจำนวนตัวอักษรหรือตัวเลขไม่มากกว่า ${15}`,
        confirm: `${this.entry.label ? this.entry.label : this.entry.placeholder} ไม่ตรงกัน`,
        after: `กรุณาเลือกหลังจาก ${this.entry.min}`,
        before: `กรุณาเลือกก่อน ${this.entry.max}`
      },
      valueField: this.entryValue ? this.entryValue : ""
    }
  },
  created() {
    if (this.entry.type === "tel") {
      this.validationMessage.min = `${this.entry.label} ต้องมีจำนวนตัวเลขไม่น้อยกว่า ${9}`
      this.validationMessage.max = `${this.entry.label} ต้องมีจำนวนตัวเลขไม่มากกว่า ${10}`
    }
    if (this.entry.type === "password") {
      this.validationMessage.min = `${this.entry.label} ต้องมีจำนวนตัวอักษรหรือตัวเลขไม่น้อยกว่า ${6}`
      this.validationMessage.max = `${this.entry.label} ต้องมีจำนวนตัวอักษรหรือตัวเลขไม่มากกว่า ${15}`
    }
  },
  computed: {
    wrapperClass() {
      return ['wrapper-class']
    },
    outerClass() {
      return this.entryDouble ? ['outer-class', 'double-time-field-class'] : this.entryTriple ? ['outer-class', 'triple-field-class'] : this.entryDoubleFull ? ['outer-class', 'double-full-field-class'] : ['outer-class']
    },
    inputClass() {
      return this.entryColumn ? ['input-class', 'options-column-class'] : ['input-class']
    },
    elementClass() {
      return this.entryVertical ? ['element-class', 'vertical-class'] : ['element-class']
    }
  },
  watch: {
    valueField(n) {
      this.validationMessage.email = `"${n}" ไม่ใช่รูปแบบของ E-mail ที่ถูกต้อง`
    }
  }
}
</script>

<style scoped>
.preview-text {
  font-size: 12px;
  text-align: end;
}

.file-input-preview {
  margin-bottom: -1.25em !important;
}

.file-input-preview-layout {
  margin-bottom: 1.5em;
}
</style>

<style>
.formulate-input .formulate-input-label {
  color: #858796;
}

.ql-container.ql-disabled {
  background: #cecece;
  opacity: 0.5;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.ql-container {
  border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px;
}

.ql-toolbar {
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
}

.input-class {
  min-height: 3.15em;
}

.formulate-input-group-item.formulate-input.input-class {
  min-height: unset;
}

.wrapper-class {
  width: 100%;
}

.vertical-class {
  display: flex;
  justify-content: space-evenly;
}

.double-time-field-class {
  width: 15%;
  margin-right: 2.6rem;
  display: inline-block;
  vertical-align: text-top;
}

.double-full-field-class {
  width: calc(50% - 20px);
  display: inline-block;
  vertical-align: text-top;
}

.double-full-field-class:nth-child(11), .double-full-field-class:nth-child(3) {
  margin-right: 35px;
}

.triple-field-class {
  width: 30%;
  display: inline-block;
  vertical-align: text-top;
}

.triple-field-class:nth-child(5), .triple-field-class:nth-child(8) {
  margin: 0 2.6rem;
}


@media only screen and (min-width: 768px) {
  .triple-field-class:nth-child(5), .triple-field-class:nth-child(8) {
    margin: 0 1.5rem;
  }
}

@media only screen and (min-width: 1024px) {
  .triple-field-class:nth-child(5), .triple-field-class:nth-child(8) {
    margin: 0 2.1rem;
  }
}

@media only screen and (min-width: 1200px) {
  .triple-field-class:nth-child(5), .triple-field-class:nth-child(8) {
    margin: 0 2.6rem;
  }
}

.options-column-class {
  display: inline-flex;
  justify-content: left;
  width: 50%;
}

.options-column-class:nth-child(2n+1) {
  padding-left: 10%;
}

.options-column-class:nth-child(2n) {
  padding-right: 10%;
}
</style>